<template>
  <div class="container-fluid">
    <div class="page-tabs">
      <a :class="{ active: currentTab === 0 }" @click.prevent="currentTab = 0">
        輪播設定
      </a>
      <a :class="{ active: currentTab === 1 }" @click.prevent="currentTab = 1">
        區塊設定
      </a>
    </div>

    <Carousel v-if="currentTab === 0" />
    <Block v-else />
  </div>
</template>

<script>
import Carousel from "@/views/back/SystemManage/HomePage/Carousel";
import Block from "@/views/back/SystemManage/HomePage/Block";

export default {
  name: "HomepageManage",

  components: {
    Carousel,
    Block,
  },
  data() {
    return {
      currentTab: 0,
    };
  },
};
</script>

<style scoped>
.page-tabs {
  cursor: pointer;
}
</style>
